import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { sessionWindowsAtomFamily } from '@/atoms/sessionWindowsAtoms';
import { useCurrentSessionId } from '@heidi/runtime/shell';

import {
  applySessionTabFocus,
  voiceSessionFocusAtom,
} from '@/composition/hosts/voice-session-tab-focus';

const FOCUS_TTL_MS = 30_000;

/**
 * Applies a pending voice ``open_artifact`` tab focus once SplitScreen has
 * seeded session windows (same-session opens often succeed immediately;
 * cross-session navigates land here after mount).
 */
export const useApplyVoiceSessionFocus = () => {
  const sessionId = useCurrentSessionId();
  const pending = useAtomValue(voiceSessionFocusAtom);
  const setPending = useSetAtom(voiceSessionFocusAtom);
  const windows = useAtomValue(
    sessionWindowsAtomFamily(sessionId ?? '__voice_focus_idle__')
  );

  useEffect(() => {
    if (!sessionId || !pending) return;
    if (pending.sessionId !== sessionId) return;
    if (Date.now() - pending.requestedAt > FOCUS_TTL_MS) {
      setPending(null);
      return;
    }
    if (!windows.sessionWindows.at(windows.activeWindowIndex ?? 0)) return;
    if (applySessionTabFocus(pending.sessionId, pending.tab)) {
      setPending(null);
    }
  }, [sessionId, pending, windows, setPending]);
};
